import styled from 'styled-components';

const Input = styled.input`
  background-color: transparent;
  border: 2px solid ${props => props.color || 'white'};
  color: ${props => props.color || 'white'};
  cursor: pointer;
  transition: all 0.1s ease-in-out;
`;

export default Input;
